'use client';

import { useState } from 'react';

import { SidebarControlButtonIconContainer, SidebarControlButtonRoot } from '../PanelLayout.styles';

import type { ReactNode } from 'react';

type SidebarControlButtonProps = {
  $active?: boolean;
  $visible?: boolean;
  'aria-hidden'?: boolean;
  'aria-label': string;
  children?: ReactNode;
  disabled?: boolean;
  hoverChildren?: ReactNode;
  onClick: () => void;
  onHoverChange?: (isHovered: boolean) => void;
  tabIndex?: number;
  type?: 'button' | 'submit' | 'reset';
};

export const SidebarControlButton = ({
  $active = false,
  $visible = true,
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  children,
  disabled = false,
  hoverChildren,
  onClick,
  onHoverChange,
  tabIndex,
  type = 'button',
}: SidebarControlButtonProps): React.ReactElement => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    onHoverChange?.(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    onHoverChange?.(false);
  };

  return (
    <SidebarControlButtonRoot
      $active={$active}
      $visible={$visible}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className="sidebar-toggle-button"
      data-active={$active}
      data-visible={$visible}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      tabIndex={tabIndex}
      type={type}
    >
      <SidebarControlButtonIconContainer>
        {isHovered && hoverChildren ? hoverChildren : children}
      </SidebarControlButtonIconContainer>
    </SidebarControlButtonRoot>
  );
};

// Backward-compatible alias while consumers migrate.
export const SidebarToggleButton = SidebarControlButton;
